import { createApi } from '@reduxjs/toolkit/query/react';

import { FileUploadDto, FileViewDto } from '../common/dto/common.dto';
import customFetchBase from './base.service';

const API_URI = import.meta.env.VITE_CORE_SERVICE;
const TAG_TYPE = 'FileUpload';
export const fileUploadApi = createApi({
  reducerPath: 'fileUploadApi',
  baseQuery: customFetchBase(`${API_URI}`),
  tagTypes: [TAG_TYPE],
  endpoints: (builder) => ({
    uploadFile: builder.mutation<FileViewDto, Partial<FileUploadDto>>({
      query(data) {
        return {
          url: `/api/file-upload`,
          method: 'POST',
          body: data,
        };
      },
    }),
  }),
});

// auto-generated based on the defined endpoints
export const { useUploadFileMutation } = fileUploadApi;
